import React from 'react';

import GenericMilestoneData from '../shared/GenericMilestoneData';

export default function ExpenseMilestoneData(props) {
    return <GenericMilestoneData {...props} />;
}
